export const getReversPercentCost = (data) => {
  if (data?.value?.properties?.reverse_discount_percent > 0) {
    const originalCost = data.value.cost
    const recalculatedCost = Math.trunc(
      (originalCost * 100) / (100 - data.value.properties.reverse_discount_percent),
    )
    return {
      oldCost: recalculatedCost,
      cost: originalCost,
    }
  }
  return {
    cost: data.value.cost,
    oldCost: data.value.properties.old_cost || null,
  }
}
